import axios from "axios";
import { ErrorMessage, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useHistory } from "react-router-dom";
import { date, number, object, ref, string } from "yup";
import Hn from "../../../../components/common/Hn";
import Icon from "../../../../components/common/Icon";
import "./createFaceTraining.css";
const uri = process.env.REACT_APP_BASE_URL;
let headers = {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};
var dte = new Date();

const validationSchema = object().shape({
  ref: string().required("Champ obligatoire."),
  dateStart: date().default(() => new Date()),
  dateEnd: date().default(() => new Date()),
  location_id: string().required("Champ obligatoire."),
  // seat_capacity_min: number().required("Champ obligatoire."),
  seat_capacity_min: number()
    .max(
      ref("seat_capacity_max"),
      "Must be less than Capacité d'acccueil maxinale"
    )
    .required("Champ obligatoire."),
  seat_capacity_max: number()
    .min(
      ref("seat_capacity_min"),
      "Must be more than Capacité d'acccueil minimale  "
    )
    .required("Champ obligatoire."),
  former: string().required("Champ obligatoire."),
});

function CreateFaceSessionElearning() {
  const fileRef = useRef();
  const [modalShow, setModalShow] = useState(false);
  const [lieuFormation, setLieuForamtion] = useState([]);
  const [formateurs, setForamteurs] = useState([]);
  const [sessions, setSessions] = useState([]);
  const onHandelStatus = (touched, error, value) => {
    if (error && touched) {
      return "danger";
    } else if (value) {
      return "info";
    } else {
      return "warning";
    }
  };
//récupérer les formateurs
  function getformer(type) {
    axios
      .get(uri+"/former")
      .then((result) => {
        setForamteurs(result?.data);
      })
      .catch((err) => {
        console.log("err formateurs", err);
      });
  }

  // récupérer toutes les sessions
  function getSessions() {
    axios
      .get(uri+"/session")
      .then((result) => {
        setSessions(result?.data);
   
      })
      .catch((err) => {
        console.log("err sessions", err);
      });
  }
  function ChangeList(value) {
    getformer(value);
  }
  useEffect(() => {
    getSessions();
    getformer("");
    axios
      .get(uri+"/location")
      .then((result) => {
        setLieuForamtion(result?.data);
      })
      .catch((err) => {
        console.log("err location", err);
      });
  }, []);

 
  let history = useHistory();
  const handleSubmit = (values) => {
    axios
      .post(`${uri}/session/new`, values, headers)
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="container lists p-5">
          <nav aria-label="breadcrumb pb-3">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#">Formations présentielles - Actions de formation</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Créer une action de formation
              </li>
            </ol>
          </nav>
          <div className="h-100 p-5 text-white bg-dark rounded-3">
            <Hn
              title="Créer une action de formation"
              level="h4"
              className="h4-size"
              plus={false}
            />
            <Hn
              title="Etap 2 : Ajout de contenu"
              level="p"
              className="py-2 fw-bold"
              plus={false}
            />

            {Object.values(sessions).map((session, index) => (
              <Accordion key={index}>
                <Accordion.Item eventKey={session?.ref}>
                  <Accordion.Header>
                    <span className="header-text">
                      {session?.training?.title}
                    </span>
                    <br />
                    <br />
                    <p className="accordion-info">
                      Du {new Date(session?.dateStart).toLocaleDateString()} au{" "}
                      <span>{session?.location?.address}</span>
                      <br></br>
                      <span>
                        {session?.former?.firstName} {session?.former?.lastName}
                      </span>
                    </p>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label className="form-label">Référence*</label>
                        <p className="header-text">{session?.ref}</p>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Date de début</label>
                        <p className="header-text">
                          {new Date(session?.dateStart).toLocaleDateString()}
                        </p>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Date de fin</label>
                        <p className="header-text">
                          {new Date(session?.dateEnd).toLocaleDateString()}
                        </p>
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">Lieu de formation*</label>
                        <p className="header-text">
                          {session?.location?.address}
                        </p>
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">Formateurs</label>
                        <p className="header-text">
                          {" "}
                          {session?.former?.organize}{" "}
                        </p>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">&nbsp;</label>
                        <p className="header-text">
                          {session?.former?.firstName}{" "}
                          {session?.former?.lastName}
                        </p>
                      </div>
                    </div>

                    <div className="row pt-5">
                      <div className="col-md-6">
                        <div className="card text-white mb-3 p-3">
                          <div className="card-body">
                            <h5 className="card-title">
                              Nom de l'unité d'apprentissage
                            </h5>
                            <div className="pt-3">
                              <Icon
                                name="localisation"
                                data="5 rue Monge, 75005 Paris"
                              />
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Icon name="Calendar" data="04/03/2022" />
                                </li>
                                <li className="list-inline-item">
                                  <Icon name="Clock" data="15h30" />
                                </li>
                                <li className="list-inline-item">
                                  <Icon
                                    name="profil"
                                    data="John Doe"
                                    style="justify-content-end"
                                  />
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="card-footer bg-transparent">
                            <Icon name="edit" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card text-white mb-3 p-3">
                          <div className="card-body">
                            <h5 className="card-title">
                              Nom de l'unité d'apprentissage
                            </h5>
                            <div className="pt-3">
                              <Icon
                                name="localisation"
                                data="5 rue Monge, 75005 Paris"
                              />
                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Icon name="Calendar" data="04/03/2022" />
                                </li>
                                <li className="list-inline-item">
                                  <Icon name="Clock" data="15h30" />
                                </li>
                                <li className="list-inline-item text-end">
                                  <Icon name="profil" data="John Doe" />
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="card-footer bg-transparent">
                            <Icon name="edit" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            ))}

            <div className="form-elements mt-2">
              <div className="form-aria p-4">
                <Formik
                  initialValues={{
                    titre: "",
                    
                  }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <form className="row g-3" onSubmit={handleSubmit}>
                      <Hn
                        title="Chapitre"
                        level="p"
                        className="py-2 fw-bold"
                        plus={false}
                      />
                      <div className="col-md-10">
                        <label className="form-label">Titre</label>
                        <input
                          status={onHandelStatus(
                            touched.ref,
                            errors.ref,
                            values.ref
                          )}
                          type="text"
                          className="form-control"
                          id="titre"
                          placeholder="Ajouter un titre"
                          onChange={handleChange("titre")}
                          value={values.titre}
                          onBlur={handleBlur("titre")}
                          errors={errors.titre}
                        />
                        <ErrorMessage name="ref">
                          {(msg) => <div className="text-danger">{msg}</div>}
                        </ErrorMessage>
                      </div>
                      <div className="col-md-2 pt-4">
                        <button
                          //href="/admin/create-session-formation-apprendre"
                          type="submit"
                          className="btn btn-outline-primary float-end"
                        >
                          Ajouter
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
              <div className="col-12 mt-5">
                <a
                  href="/admin/create-formation-presentielle"
                  className="btn btn-link resetBtn"
                >
                  Annuler
                </a>
                <a
                  type="submit"
                  className="btn btn-primary float-end"
                  disabled
                  href="/admin/create-session-formation-elearning2"
                >
                  Suivant
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateFaceSessionElearning;
